export const miscInstructionsHeader = "Hinweise";

export const miscInstructionsTexts = [
  {
    type: "subtitle",
    content: "In der Flusshistorie sind viele Lücken in den Graphen zu sehen.",
  },
  {
    type: "text",
    content:
      "Ist die Flusshistorie sehr lückenhaft, ist dies darauf zurückzuführen, dass Ihr Energieimpuls regelmäßig keine " +
      "Daten sendet. Dies liegt an einer schlechten Internetverbindung. Wir raten Ihnen, eine bessere " +
      "Internetverbindung herzustellen, um einen reibungslosen Betrieb des Energieimpulses sicherzustellen. Dazu " +
      "eignet sich beispielsweise ein Repeater, um Ihr WLAN-Signal zu verstärken, oder bestenfalls eine direkte " +
      "LAN-Verbindung zum Energieimpuls.",
  },
  { type: "space" },
  {
    type: "subtitle",
    content:
      "In der Energiefluss-Übersicht sind inkonsistente Zustände zu verzeichnen.",
  },
  {
    type: "text",
    content:
      "Inkonsistente Zustände in der Flussübersicht können auf zwei Gründe zurückgeführt werden:",
  },
  {
    type: "enumeration",
    content: [
      "Transiente Vorgänge des Wechselrichters: Ist ein inkonsistenter Zustand nur für ein paar Sekunden zu " +
        "verzeichnen, kann dies darauf zurückgeführt werden, dass die Steuerungsvoränge des Wechselrichters zum " +
        "Zeitpunkt des Auslesens noch nicht abgeschlossen waren.",
      "Unterschiedliche zeitliche Auflösung der Daten: Ist Ihr Energieimpuls nicht an alle Ihre Geräte - wie bspw. " +
        "einen zweiten Wechselrichter - angeschlossen, sondern werden Daten Ihrer Geräte direkt vom Anbieter " +
        "(bspw. Growatt) ausgelesen, kann dies zur unterschiedlichen zeitlichen Auflösung der Daten führen. Während " +
        "der Energieimpuls fortlaufend die Daten Ihrer Geräte ausliest und in kurzen zeitlichen Abständen übermittelt, werden " +
        "bei Anbietern wie bspw. Growatt, die Daten in 5-minütiger Auflösung zur Verfügung gestellt.",
    ],
  },
  { type: "space" },
  {
    type: "subtitle",
    content: "Es wird nicht der richtige Ladestrom meiner Wallbox angezeigt.",
  },
  {
    type: "text",
    content:
      "In Abhängigkeit Ihres Wallbox-Modells wird nicht der tatsächliche, " +
      "sondern der von der Wallbox zur Verfügung gestellte Strom angezeigt. " +
      "Sollte Ihr Auto bspw. wegen einer entsprechenden Einstellung " +
      "über Ihre Fahrzeug-App einen anderen Ladestrom beziehen, wird " +
      "der durch Ihre Fahrzeug-App anders eingestellte Ladestrom nicht bei " +
      "allen Wallbox-Modellen angezeigt, wenn kein zusätzlicher Zähler verbaut ist. " +
      "Stattdessen wird der durch die Wallbox bereitgestellte Strom, den Ihr " +
      "Fahrzeug maximal beziehen kann, aufgeführt.",
  },
];
